<template>
  <div class="mgt-10px VueTables">
    <div class="table-responsive">
      <table class="VueTables__table table is-striped-reverse is-bordered is-fullwidth">
        <thead>
        <th class="width-40">{{ $t('detail.commande.lignesCommande.description') }}</th>
        <th>{{ $t('detail.commande.lignesCommande.quantity') }}</th>
        <th>{{ $t('detail.commande.lignesCommande.unit') }}</th>
        <th>{{ $t('detail.commande.lignesCommande.priceUnit') }}</th>
        <th v-if="!isPrevisualisation">{{ $t('detail.commande.lignesCommande.montantBrut') }}</th>
        <th v-if="displayRemise"
            @click="masqueRemiseChange"
            @mouseover="setHoverOfAllLigne(true)"
            @mouseleave="setHoverOfAllLigne(false)"
            :class="[{ 'is-cursor-pointer' : isEditPrevisu && !findLigneWithMasqueLigne },
            { 'has-background-select' : hoverColumnRemise },
            { 'has-background-selectPrev' : masqueRemise && !hoverColumnRemise && isEditPrevisu}]">
          <div class="is-position-relative">
            <div class="is-position-relative"
                 :class="{ 'opacity-ligne-select' : masqueRemise && isEditPrevisu }">
              {{ $t('detail.commande.lignesCommande.discount') }}
            </div>
          </div>
        </th>
        <th v-else> {{ $t('detail.commande.lignesCommande.montantBrut') }} </th>
        <th>{{ $t('detail.commande.lignesCommande.tva') }}</th>
        <th v-if="displayRemise">{{ $t('detail.commande.lignesCommande.amount') }}</th>
        <th v-else> {{ $t('detail.commande.lignesCommande.montantNet') }} </th>
        </thead>
        <tbody>
        <template v-for="(ligne, index) in loading ? lignesCommande : lignesCommande">
          <tr v-if="isNormal(ligne) || isRegroupementPersonalise(ligne)"
            :key="index"
            :class="{ 'has-background-select' : ligne.commandeId
            && !isPrevisualisation && dcfIsCommandePartiellement }">
            <td v-if="sens === sensVente">
              <div class="is-position-relative is-flex is-spaced-between">
                <div class="is-position-relative">
                  <p v-if="ligne.typeProduit === CATEGORIE_DISPOSITIF">
                    <span v-html="ligne.description"></span>
                    <br/>
                    <small v-if="ligne.ligneCommandeDispositif.nomenclatureTypeId">
                      <info-nomenclature
                        :nomenclature="ligne.ligneCommandeDispositif.nomenclature">
                      </info-nomenclature>
                    </small>
                  </p>
                  <p v-else class="table__label-produit is-prewrap is-word-break">
                    {{ligne.libelle}}
                  </p>
                  <router-link-blank v-if="ligne.commandeId && dcfIsCommandePartiellement"
                                    class-message="is-size-7"
                                    :to="{ name: 'c.bodac.commandes',
                        params: {id: ligne.commandeId}}"
                                    :message="$t('detailDevis.commandePartiel.produitCommander')">
                  </router-link-blank>
                  <ligne-issue-commande v-if="referencesCommandes && referencesCommandes.length > 0
                                        && ligne.commandeId"
                                        :ligne-commande="ligne"
                                        :references-commande="referencesCommandes">
                  </ligne-issue-commande>
                </div>
                <div class="has-text-right">
                  <a v-if="isRegroupementPersonaliseWithReseauTempo(ligne)"
                     @click="openInfoFacesSelectReseauPersoOfReseauTempo(ligne)">
                    <b-icon icon="information"
                            type="is-success"
                            size="is-small">
                    </b-icon>
                  </a>
                </div>
                <div v-if="isConsultable(ligne.typeProduit, ligne.produitId)"
                  class="has-text-right">
                  <router-link-blank
                    class-message="is-size-7"
                    :to="{
                      name: getNameRoute(ligne.typeProduit),
                      params: {
                        id: ligne.produitId,
                        isFromListeProduitReseau: false,
                        dateVisu: formatDate(ligne.dateDebut),
                      }
                    }"
                    icon="open-in-new"
                    classMessage="mgl-10px"
                    typeIcon="is-primary"
                    sizeIcon="is-small">
                  </router-link-blank>
                </div>
                <div class="has-text-right"
                  v-if="moduleStockTiersActive
                  && ligne.produit
                  && ligne.produit.stockable
                  && etatDcf != SANS_SUITE">
                  <b-tooltip :label="$t('detail.commande.bonStockEntree')">
                    <router-link-blank
                      :to="{
                        name: routeNameStockEntree,
                        params: {
                            ligneCommandeId: ligne.id,
                          }
                        }"
                      icon="warehouse"
                      classMessage="mgl-10px"
                      typeIcon="is-success"
                      sizeIcon="is-small">
                    </router-link-blank>
                  </b-tooltip>
                </div>
              </div>
            </td>
            <td v-else>
              <div class="is-position-relative is-flex is-spaced-between">
                <span v-html="ligne.description"></span>
                <div v-if="isConsultable(ligne.typeProduit, ligne.produitId)"
                     class="has-text-right">
                  <router-link-blank
                    class-message="is-size-7"
                    :to="{
                      name: getNameRoute(ligne.typeProduit),
                      params: {
                        id: ligne.produitId,
                        isFromListeProduitReseau: false,
                        dateVisu: formatDate(ligne.dateDebut),
                      }
                    }"
                    icon="open-in-new"
                    classMessage="mgl-10px"
                    typeIcon="is-primary"
                    sizeIcon="is-small">
                  </router-link-blank>
                </div>
              </div>
            </td>
            <td class="right">{{ ligne.quantite }}</td>
            <td>{{ $t(`detail.periodicity.${ligne.uniteVente}`) }}</td>
            <td class="right">{{ ligne.prixUnitaire }}</td>
            <td class="right" v-if="!isPrevisualisation">
              {{ getMontantBrutDeuxDecimal(ligne, ligne.lignesCommande)| formatDeviseForDetail }}
            </td>
            <td class="right" v-if="displayRemise"
                @mouseover="setHoverOfAllLigne(true)"
                @mouseleave="setHoverOfAllLigne(false)"
                @click="masqueRemiseChange"
                :class="[{ 'is-cursor-pointer' : isEditPrevisu && !findLigneWithMasqueLigne },
            { 'has-background-select' : hoverColumnRemise },
            { 'has-background-selectPrev' : masqueRemise && !hoverColumnRemise && isEditPrevisu} ]">
              <detail-ligne-commande-case-remise
                :masqueRemise="masqueRemise"
                :hover="hoverColumnRemise"
                :isEditPrevisu="isEditPrevisu"
                :remise="ligne.remise">
              </detail-ligne-commande-case-remise>
            </td>
            <td v-else class="right">
              {{ getMontantBrut(ligne, ligne.lignesCommande) | formatDeviseForDetail }}
            </td>
            <td class="right">{{ ligne.tauxTva }}&nbsp;%</td>
            <td class="right">
              {{ getMontantNet(ligne, ligne.lignesCommande) | formatDeviseForDetail }}
            </td>
          </tr>
          <tr v-if="isRemise(ligne)" :key="index">
            <td :colspan="displayRemise ? !isPrevisualisation ? 5 : 4 : 6">
              <strong class="table__label-produit
                is-prewrap is-word-break">{{ligne.libelle}}</strong>
            </td>
            <td class="right" v-if="displayRemise"
                @mouseover="setHoverOfAllLigne(true)"
                @mouseleave="setHoverOfAllLigne(false)"
                @click="masqueRemiseChange"
                :class="[{ 'is-cursor-pointer' : isEditPrevisu && !findLigneWithMasqueLigne },
            { 'has-background-select' : hoverColumnRemise },
            { 'has-background-selectPrev' : masqueRemise && !hoverColumnRemise && isEditPrevisu} ]">
              <detail-ligne-commande-case-remise
                :masqueRemise="masqueRemise"
                :hover="hoverColumnRemise"
                :isEditPrevisu="isEditPrevisu"
                :remise="ligne.remise">
              </detail-ligne-commande-case-remise>
            </td>
            <td class="right" colspan="2">{{ ligne.totalHt }}</td>
          </tr>
          <template v-if="afficherLigneRemise(ligne)">
            <detail-ligne-remise-personalise v-for="remise in ligne.lignesRemise"
                                             :key="'remise-' + remise.id"
                                             :remise="remise"
                                             :masqueRemise="masqueRemise"
                                             :isEditPrevisu="isEditPrevisu"
                                             :isPrevisualisation="isPrevisualisation"
                                             :hover="hoverColumnRemise">
            </detail-ligne-remise-personalise>
          </template>
          <template v-if="isRegroupement(ligne)">
            <template v-for="(ligneEnfant, indexEnfant) in ligne.lignesCommande">
              <tr v-if="!isCommentaire(ligneEnfant) && displayLigne(ligneEnfant)"
                  :key="index + '-' + indexEnfant"
                  :class="[{ 'has-background-select' : ligneEnfant.hover
                  || (ligne.commandeId && !isPrevisualisation && dcfIsCommandePartiellement) },
                  { 'has-background-selectPrev' : ligneEnfant.masqueLigne
                  && !ligneEnfant.hover && isEditPrevisu }]">
                <td @mouseover="setHoverLigneEnfant(ligneEnfant, true, ligne.lignesCommande)"
                    @mouseleave="setHoverLigneEnfant(ligneEnfant, false, ligne.lignesCommande)"
                    @click="masqueLigne(ligneEnfant, ligne.lignesCommande)"
                    :class="{ 'is-cursor-pointer' :
                    isEditPrevisu && tauxTvaIsSame(ligne.lignesCommande)
                  && (ligneEnfant.typeProduit === CATEGORIE_DIVERS || !ligneEnfant.typeProduit)}">
                  <div class="is-position-relative is-flex is-spaced-between">
                    <div class="is-position-relative"
                         :class="{ 'opacity-ligne-select' : ligneEnfant.masqueLigne
                     && !ligneEnfant.hover && isEditPrevisu }">
                      <span v-html="ligneEnfant.description">
                      </span>
                      <span v-if="ligne.typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE">
                        <small>{{ $t('detail.commande.lignesCommande.ecranAssocies') }}
                        {{ getNbEcranAssocies(ligne) }}
                        </small>
                      </span>
                      <span v-if="ligneEnfant.afficherObjectif">
                        <small>
                          {{ $t('detail.commande.lignesCommande.montantFace') }}
                          {{ ligneEnfant.montantFace | formatDevise }}
                          <b-tooltip v-if="ligneEnfant.objectif"
                            type="is-primary"
                            position="is-right"
                            :label="ligneEnfant.objectifAtteint ?
                              $t('detail.commande.lignesCommande.objectifAtteint',
                                { objectif: ligneEnfant.objectif })
                              : $t('detail.commande.lignesCommande.objectifNonAtteint',
                              { objectif: ligneEnfant.objectif })">
                            <b-icon
                              :type="ligneEnfant.objectifAtteint ? 'is-success' : 'is-danger'"
                              size="is-small"
                              icon="checkbox-blank-circle">
                            </b-icon>
                          </b-tooltip>
                        </small>
                      </span>
                    </div>
                    <div v-if="(ligneEnfant.masqueLigne || ligneEnfant.hover) && isEditPrevisu"
                         class="height-21px has-text-centered eyes-icon-aligement">
                      <b-icon :icon="((ligneEnfant.masqueLigne && !ligneEnfant.hover)
                        || (ligneEnfant.hover && !ligneEnfant.masqueLigne)) ? 'eye-off' : 'eye'"
                              custom-size="mdi-16px"
                              type="is-link"
                              :class="[{ 'white-round-22': ligneEnfant.hover },
                          { 'opacity-ligne-select': ligneEnfant.masqueLigne
                          && !ligneEnfant.hover }]"
                      ></b-icon>
                    </div>
                    <div class="has-text-right"
                         v-if="isConsultable(ligne.typeProduit, ligne.produitId)
                         && indexEnfant === 0">
                      <router-link-blank
                        v-if="afficherLien"
                        :to="{
                          name: getNameRoute(ligne.typeProduit),
                          params: {
                            id: ligne.produitId,
                            isFromListeProduitReseau: false,
                            dateVisu: formatDate(ligne.dateDebut),
                          }
                        }"
                        icon="open-in-new"
                        classMessage="mgl-10px"
                        typeIcon="is-primary"
                        sizeIcon="is-small">
                      </router-link-blank>
                      <div v-if="isConsultable(ligneEnfant.typeProduit, ligneEnfant.produitId)
                               && indexEnfant === 0">
                        <b-tooltip
                          :label="$t('detail.commande.lignesCommande.tooltip.lienLocation')"
                          :active ="ligneEnfant.typeProduit === constantes.CATEGORIE_LOCATION">
                          <router-link-blank
                            v-if="afficherLien"
                            :to="{
                                name: getNameRoute(ligneEnfant.typeProduit),
                                params: {
                                  id: ligneEnfant.produitId,
                                  isFromListeProduitReseau: false,
                                  dateVisu: formatDate(ligneEnfant.dateDebut),
                                }
                              }"
                            :icon="ligneEnfant.typeProduit === constantes.CATEGORIE_LOCATION
                              ?'hand-extended-outline'
                              : 'open-in-new'"
                            classMessage="mgl-10px"
                            typeIcon="is-primary"
                            sizeIcon="is-small">
                          </router-link-blank>
                        </b-tooltip>
                      </div>
                      <a
                        v-if="shouldDisplayFaceSelectedInfo(ligne)"
                        @click="openInfoFacesSelectReseau(ligne)">
                        <b-icon icon="information" type="is-success" size="is-small"></b-icon>
                      </a>
                    </div>
                    <div class="has-text-right"
                         v-if="isConsultable(ligneEnfant.typeProduit, ligneEnfant.produitId)
                       && indexEnfant > 0">
                      <router-link-blank
                        v-if="afficherLien"
                        :to="{
                        name: getNameRoute(ligneEnfant.typeProduit),
                        params: {
                          id: ligneEnfant.produitId,
                          isFromListeProduitReseau: false,
                          dateVisu: formatDate(ligneEnfant.dateDebut),
                        }
                      }"
                        icon="open-in-new"
                        classMessage="mgl-10px"
                        typeIcon="is-primary"
                        sizeIcon="is-small">
                      </router-link-blank>
                    </div>
                    <div class="has-text-right"
                      v-if="moduleStockTiersActive
                        && ligneEnfant.produit
                        && ligneEnfant.produit.stockable
                        && etatDcf != SANS_SUITE">
                      <b-tooltip :label="$t('detail.commande.bonStockEntree')">
                        <router-link-blank
                          :to="{
                            name: routeNameStockEntree,
                            params: {
                                ligneCommandeId: ligneEnfant.id,
                              }
                            }"
                          icon="warehouse"
                          classMessage="mgl-10px"
                          typeIcon="is-success"
                          sizeIcon="is-small">
                        </router-link-blank>
                      </b-tooltip>
                    </div>
                  </div>
                  <router-link-blank v-if="ligne.commandeId && dcfIsCommandePartiellement"
                                     class-message="is-size-7"
                                     :to="{ name: 'c.bodac.commandes',
                    params: {id: ligne.commandeId}}"
                                     :message="$t('detailDevis.commandePartiel.produitCommander')">
                  </router-link-blank>
                  <ligne-issue-commande v-if="referencesCommandes && referencesCommandes.length > 0
                  && ligne.commandeId && indexEnfant === 0"
                                        :ligne-commande="ligne"
                                        :references-commande="referencesCommandes">
                  </ligne-issue-commande>
                </td>
                <td class="right" @click="masqueLigne(ligneEnfant, ligne.lignesCommande)"
                    @mouseover="setHoverLigneEnfant(ligneEnfant, true, ligne.lignesCommande)"
                    @mouseleave="setHoverLigneEnfant(ligneEnfant, false, ligne.lignesCommande)"
                    :class="[{ 'opacity-ligne-select' : ligneEnfant.masqueLigne
                     && !ligneEnfant.hover && isEditPrevisu },
                     { 'is-cursor-pointer' : isEditPrevisu && tauxTvaIsSame(ligne.lignesCommande)
                  && (ligneEnfant.typeProduit === CATEGORIE_DIVERS || !ligneEnfant.typeProduit)}]">
                  {{ ligneEnfant.quantite }}
                </td>
                <td @mouseover="setHoverLigneEnfant(ligneEnfant, true, ligne.lignesCommande)"
                    @mouseleave="setHoverLigneEnfant(ligneEnfant, false, ligne.lignesCommande)"
                    @click="masqueLigne(ligneEnfant, ligne.lignesCommande)"
                    :class="[{ 'opacity-ligne-select' : ligneEnfant.masqueLigne
                     && !ligneEnfant.hover && isEditPrevisu },
                     { 'is-cursor-pointer' : isEditPrevisu && tauxTvaIsSame(ligne.lignesCommande)
                  && (ligneEnfant.typeProduit === CATEGORIE_DIVERS || !ligneEnfant.typeProduit)}]">
                  {{ $t(`detail.periodicity.${ligneEnfant.uniteVente}`) }}
                </td>
                <td @mouseover="setHoverLigneEnfant(ligneEnfant, true, ligne.lignesCommande)"
                    @mouseleave="setHoverLigneEnfant(ligneEnfant, false, ligne.lignesCommande)"
                    @click="masqueLigne(ligneEnfant, ligne.lignesCommande)"
                    class="right" :class="[{ 'opacity-ligne-select' : ligneEnfant.masqueLigne
                     && !ligneEnfant.hover && isEditPrevisu },
                     { 'is-cursor-pointer' : isEditPrevisu && tauxTvaIsSame(ligne.lignesCommande)
                  && (ligneEnfant.typeProduit === CATEGORIE_DIVERS || !ligneEnfant.typeProduit)}]">
                  {{ getPrixUnitaire(ligneEnfant, ligne.lignesCommande) | formatDeviseForDetail }}
                </td>
                <td class="right" v-if="!isPrevisualisation">
                  {{ getMontantBrutDeuxDecimal(ligneEnfant, ligne.lignesCommande)
                  | formatDeviseForDetail }}
                </td>
                <td class="right" v-if="displayRemise"
                    @mouseover="setHoverOfAllLigne(true)"
                    @mouseleave="setHoverOfAllLigne(false)"
                    @click="masqueRemiseChange"
                    :class="[{ 'is-cursor-pointer' : isEditPrevisu && !findLigneWithMasqueLigne },
            { 'has-background-select' : hoverColumnRemise },
            { 'has-background-selectPrev' : masqueRemise && !hoverColumnRemise && isEditPrevisu} ]">
                  <detail-ligne-commande-case-remise
                    :masqueRemise="masqueRemise"
                    :hover="hoverColumnRemise"
                    :isEditPrevisu="isEditPrevisu"
                    :remise="ligneEnfant.remise">
                  </detail-ligne-commande-case-remise>
                </td>
                <td v-else class="right">
                  {{ getMontantBrut(ligneEnfant, ligne.lignesCommande) | formatDeviseForDetail }}
                </td>
                <td @mouseover="setHoverLigneEnfant(ligneEnfant, true, ligne.lignesCommande)"
                    @mouseleave="setHoverLigneEnfant(ligneEnfant, false, ligne.lignesCommande)"
                    @click="masqueLigne(ligneEnfant, ligne.lignesCommande)"
                    class="right" :class="[{ 'opacity-ligne-select' : ligneEnfant.masqueLigne
                     && !ligneEnfant.hover && isEditPrevisu },
                     { 'is-cursor-pointer' : isEditPrevisu && tauxTvaIsSame(ligne.lignesCommande)
                  && (ligneEnfant.typeProduit === CATEGORIE_DIVERS || !ligneEnfant.typeProduit)}]">
                  {{ ligneEnfant.tauxTva }}&nbsp;%
                </td>
                <td @mouseover="setHoverLigneEnfant(ligneEnfant, true, ligne.lignesCommande)"
                    @mouseleave="setHoverLigneEnfant(ligneEnfant, false, ligne.lignesCommande)"
                    @click="masqueLigne(ligneEnfant, ligne.lignesCommande)"
                    class="right" :class="[mustBeItalicAndThrough(ligne),
                  { 'opacity-ligne-select' : ligneEnfant.masqueLigne
                     && !ligneEnfant.hover && isEditPrevisu },
                     { 'is-cursor-pointer' : isEditPrevisu && tauxTvaIsSame(ligne.lignesCommande)
                  && (ligneEnfant.typeProduit === CATEGORIE_DIVERS || !ligneEnfant.typeProduit)}]">
                  {{ getMontantNet(ligneEnfant, ligne.lignesCommande) | formatDeviseForDetail }}
                </td>
              </tr>
              <template v-if="afficherLigneRemise(ligneEnfant)">
                <detail-ligne-remise-personalise v-for="remise in ligneEnfant.lignesRemise"
                                                 :key="'remise-' + remise.id"
                                                 :masqueRemise="masqueRemise"
                                                 :hover="hoverColumnRemise"
                                                 :isEditPrevisu="isEditPrevisu"
                                                 :isPrevisualisation="isPrevisualisation"
                                                 :remise="remise">
                </detail-ligne-remise-personalise>
              </template>
            </template>
            <template v-if="ligne.lignesCommande.length === 0">
              <tr :key="ligne.id">
                <td>
                  <p class="table__label-produit is-prewrap is-word-break">
                    <span> {{ ligne.libelle }} </span>
                    <a
                      v-if="shouldDisplayFaceSelectedInfo(ligne)"
                      @click="openInfoFacesSelectReseau(ligne)"
                      class="is-pulled-right">
                      <b-icon icon="information" type="is-success" size="is-small"></b-icon>
                    </a>
                  </p>
                  <router-link-blank v-if="ligne.commandeId && dcfIsCommandePartiellement"
                                     class-message="is-size-7"
                                     :to="{ name: 'c.bodac.commandes',
                    params: {id: ligne.commandeId}}"
                                     :message="$t('detailDevis.commandePartiel.produitCommander')">
                  </router-link-blank>
                  <ligne-issue-commande v-if="referencesCommandes && referencesCommandes.length > 0
                                    && ligne.commandeId"
                                        :ligne-commande="ligne"
                                        :references-commande="referencesCommandes">
                  </ligne-issue-commande>
                </td>
                <td class="right">{{ ligne.quantite }}</td>
                <td>{{ $t(`detail.periodicity.${ligne.uniteVente}`) }}</td>
                <td class="right">{{ ligne.prixUnitaire }}</td>
                <td class="right" v-if="!isPrevisualisation">
                  {{ getMontantBrutDeuxDecimal(ligne, ligne.lignesCommande)
                  | formatDeviseForDetail }}
                </td>
                <td class="right" v-if="displayRemise"
                    @mouseover="setHoverOfAllLigne(true)"
                    @mouseleave="setHoverOfAllLigne(false)"
                    @click="masqueRemiseChange"
                    :class="[{ 'is-cursor-pointer' : isEditPrevisu && !findLigneWithMasqueLigne },
            { 'has-background-select' : hoverColumnRemise },
            { 'has-background-selectPrev' : masqueRemise && !hoverColumnRemise && isEditPrevisu} ]">
                  <detail-ligne-commande-case-remise
                    :masqueRemise="masqueRemise"
                    :hover="hoverColumnRemise"
                    :isEditPrevisu="isEditPrevisu"
                    :remise="ligne.remise">
                  </detail-ligne-commande-case-remise>
                </td>
                <td v-else class="right">
                  {{ getMontantBrut(ligne, ligne.lignesCommande) | formatDeviseForDetail }}
                </td>
                <td class="right">{{ ligne.tauxTva }}&nbsp;%</td>
                <td class="right">
                  {{ getMontantNet(ligne, ligne.lignesCommande) | formatDeviseForDetail }}
                </td>
              </tr>
            </template>
          </template>
          <tr v-else-if="isSousTotal(ligne)"
              :key="index">
            <td colspan="7">
              <strong class="table__label-produit
                is-prewrap is-word-break">{{ligne.libelle}}</strong>
            </td>
            <td class="right">{{ ligne.totalHt }}</td>
          </tr>
          <tr v-else-if="isCommentaire(ligne)"
              :key="index">
            <td colspan="8">
              <span class="is-prewrap is-word-break">{{ligne.libelle}}</span>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <b-modal
      v-model="popUpSelectionFace"
      width="1400px"
      class="modal"
      has-modal-card>
      <pop-up-selection-face
        v-if="ligneSelect"
        :display-column-logistique="typeDCF === TYPE_COMMANDE"
        :ligneSelect="ligneSelect"
        :is-detail="true"
        :permissions="permsDcf"
        :typeDcf="typeDCF">
      </pop-up-selection-face>
    </b-modal>
    <b-modal v-model="popUpSelectionFaceReseauPerso"
             has-modal-card width="1200px"
             class="modal">
      <pop-up-select-faces-in-reseau-tempo v-if="ligneReseauTempoOfReseauPerso.length > 0"
                             :display-column-logistique="typeDCF === TYPE_COMMANDE"
                             :ligneReseauTempoOfReseauPerso="ligneReseauTempoOfReseauPerso">
      </pop-up-select-faces-in-reseau-tempo>
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import * as devisConf from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import getRouteOfPatrimonialProduct from '@/services/catalogue/getRouteOfPatrimonialProduct';
import {
  CATEGORIE_DIVERS,
  CATEGORIE_ECRAN_NUMERIQUE,
  CATEGORIE_LOCATION,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_SALON,
  CATEGORIE_SPONSORING,
  CATEGORIE_AUTRE,
  CATEGORIE_UNITAIRE,
  CATEGORIE_PRESSE,
  CATEGORIE_DISPOSITIF,
  CATEGORIE_REGROUPEMENT_MAIRIE,
  CATEGORIE_IMPRESSION_AFFICHE,
} from '@/configuration/catalogue/produitConf';
import { INDISPONIBLE, SANS_SUITE, ANNULATION } from '@/configuration/optionBlocage/optionBlocage';
import { FACTURES, DEVIS, COMMANDES } from '@/configuration/permissionsBodacConf';
import detailLigneRemisePersonalise from '@/components/devisCommandes/detailDevisCommande/detailLigneRemisePersonalise';
import detailLigneCommandeCaseRemise from '@/components/devisCommandeFacture/detail/detailLigneCommandeCaseRemise';
import findLigneWithMasqueLigne from '@/services/devisCommandes/ligneCommande/findLigneWithMasqueLigne';
import { ajoutDevise } from '@/services/general/filters/formatDevise';
import decimalsFormaterService from '@/services/general/decimalsFormater';
import popUpSelectionFace from '@/components/devisCommandeFacture/facesSelectInReseauTempo/p_selectFaces';
import ligneIssueCommande from '@/components/factures/editionFacture/ligneIssueCommande';
import calculArrondi from '@/services/calcul/calculArrondi';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import getDisponibilite from '@/services/devisCommandes/getDisponibiliteTempo';
import { INFINITE_DAY } from '@/configuration/general';
import moment from 'moment';
import formatDate from '@/services/general/formatIsoDate';
import popUpSelectFacesInReseauTempo from '@/components/devisCommandeFacture/facesSelectInReseauTempoOfReseauPerso/p_selectFacesInReseauTempo';
import { DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID } from '@/configuration/bonStock/menuStockConf';
import infoNomenclature from './infoNomenclature';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    lignesCommande: {
      type: Array,
      required: true,
    },
    typeDCF: {
      type: String,
      required: true,
    },
    masqueRemise: {
      type: Boolean,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: true,
    },
    isPrevisualisation: {
      type: Boolean,
      required: true,
    },
    etatDcf: {
      type: String,
      required: false,
      default: null,
    },
    referencesCommandes: {
      type: Array,
      required: false,
    },
    sens: {
      type: String,
      required: false,
      default: devisConf.SENS_VENTE,
    },
    afficherLien: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      hoverColumnRemise: false,
      CATEGORIE_DIVERS: CATEGORIE_DIVERS,
      ligneSelect: null,
      popUpSelectionFace: false,
      CATEGORIE_REGROUPEMENT: CATEGORIE_REGROUPEMENT,
      TYPE_COMMANDE: devisConf.TYPE_COMMANDE,
      sensVente: devisConf.SENS_VENTE,
      loading: false,
      CATEGORIE_REGROUPEMENT_NUMERIQUE: CATEGORIE_REGROUPEMENT_NUMERIQUE,
      PERSONNALISE: devisConf.PERSONNALISE,
      ligneReseauTempoOfReseauPerso: [],
      popUpSelectionFaceReseauPerso: false,
      CATEGORIE_DISPOSITIF: CATEGORIE_DISPOSITIF,
      formatDate,
      routeNameStockEntree: DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID,
      constantes: {
        CATEGORIE_REGROUPEMENT_MAIRIE,
        CATEGORIE_LOCATION,
      },
    };
  },
  filters: {
    formatDeviseForDetail(prix) {
      return ajoutDevise(decimalsFormaterService(prix));
    },
  },
  components: {
    routerLinkBlank,
    detailLigneRemisePersonalise,
    detailLigneCommandeCaseRemise,
    popUpSelectionFace,
    ligneIssueCommande,
    popUpSelectFacesInReseauTempo,
    infoNomenclature,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    displayRemise() {
      return !!(this.isEditPrevisu || !this.isPrevisualisation || !this.masqueRemise);
    },
    findLigneWithMasqueLigne() {
      return findLigneWithMasqueLigne(this.lignesCommande);
    },
    dcfIsCommandePartiellement() {
      return this.etatDcf === devisConf.ETAT_COMMANDE_PARTIELLEMENT;
    },
    permsDcf() {
      switch (this.typeDCF) {
        case devisConf.TYPE_COMMANDE:
          return COMMANDES;
        case devisConf.TYPE_FACTURE:
          return FACTURES;
        default:
          return DEVIS;
      }
    },
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    openInfoFacesSelectReseau(ligne) {
      this.ligneSelect = cloneDeep(ligne);
      this.popUpSelectionFace = true;
    },
    setHoverOfAllLigne(state) {
      if (!this.isPrevisualisation || (!this.masqueRemise && !this.isEditPrevisu)
        || this.findLigneWithMasqueLigne) return;
      this.hoverColumnRemise = state;
    },
    displayLigne(ligne) {
      return !!(this.isEditPrevisu || !this.isPrevisualisation || !ligne.masqueLigne);
    },
    setHoverLigneEnfant(ligne, hover, lignesEnfant) {
      if ((ligne.typeProduit === CATEGORIE_DIVERS || !ligne.typeProduit) && this.isEditPrevisu
        && this.tauxTvaIsSame(lignesEnfant)) ligne.hover = hover;
    },
    masqueRemiseChange() {
      if (this.isEditPrevisu && !this.findLigneWithMasqueLigne) {
        this.$emit('masqueRemiseChange', !this.masqueRemise);
      }
    },
    tauxTvaIsSame(lignes) {
      return (new Set(lignes.filter(l => l.type !== devisConf.COMMENTAIRE)
        .map(l => l.tauxTva))).size === 1;
    },
    masqueLigne(ligne, lignesEnfants) {
      if ((ligne.typeProduit === CATEGORIE_DIVERS || !ligne.typeProduit)
        && this.tauxTvaIsSame(lignesEnfants) && this.isEditPrevisu) {
        this.$emit('masqueLigneChange', ligne);
      }
    },
    getMontantBrutDeuxDecimal(ligne, lignesEnfant) {
      return calculArrondi(this.getMontantBrut(ligne, lignesEnfant), 2);
    },
    isConsultable(produitType, produitId) {
      return produitId && (produitType === CATEGORIE_UNITAIRE
        || produitType === CATEGORIE_REGROUPEMENT
        || produitType === CATEGORIE_ECRAN_NUMERIQUE
        || produitType === CATEGORIE_SALON
        || produitType === CATEGORIE_SPONSORING
        || produitType === CATEGORIE_AUTRE
        || produitType === CATEGORIE_PRESSE
        || produitType === CATEGORIE_DIVERS
        || produitType === CATEGORIE_IMPRESSION_AFFICHE
        || produitType === CATEGORIE_DISPOSITIF
        || produitType === CATEGORIE_REGROUPEMENT_NUMERIQUE
        || produitType === CATEGORIE_REGROUPEMENT_MAIRIE
        || produitType === CATEGORIE_LOCATION
        || produitType === CATEGORIE_REGROUPEMENT_LC);
    },
    getTotalHtLigneMasque(lignesEnfant) {
      const lignesMasquees = lignesEnfant.filter((ligne) => { return ligne.masqueLigne; });
      let totalHtLigneMasque = 0;
      lignesMasquees.forEach((ligneMasque) => {
        totalHtLigneMasque += ligneMasque.totalHtNonTransform;
      });
      return totalHtLigneMasque;
    },
    getMontantNet(ligne, lignesEnfant) {
      if (!this.isEditPrevisu && ligne.typeProduit === CATEGORIE_LOCATION
        && this.isPrevisualisation) {
        return ligne.totalHtNonTransform + this.getTotalHtLigneMasque(lignesEnfant);
      }
      return ligne.totalHtNonTransform;
    },
    getMontantBrut(ligne, lignesEnfant) {
      if (ligne.uniteVente === devisConf.POURCENTAGE) {
        return ((Number(ligne.quantite)) * this.getPrixUnitaire(ligne, lignesEnfant)) / 100;
      }
      return (Number(ligne.quantite)) * this.getPrixUnitaire(ligne, lignesEnfant);
    },
    getPrixUnitaire(ligne, lignesEnfant) {
      if (!this.isEditPrevisu && ligne.typeProduit === CATEGORIE_LOCATION
        && this.isPrevisualisation) {
        if (Number(ligne.quantite) === 0) return 0.00;
        return ligne.prixUnitaireNonTransform + (
          this.getTotalHtLigneMasque(lignesEnfant) / Number(ligne.quantite)
        );
      }
      return ligne.prixUnitaireNonTransform;
    },
    mustBeItalicAndThrough(ligne) {
      if (this.typeDCF === devisConf.TYPE_DEVIS
        && ligne.type === devisConf.REGROUPEMENT
        && ligne.typeProduit === CATEGORIE_REGROUPEMENT
        && (ligne.etatObtenu === SANS_SUITE
          || ligne.etatObtenu === INDISPONIBLE || ligne.etatObtenu === ANNULATION)) {
        return { 'is-italic': true, textDecorationLineThrough: true };
      }
      return {};
    },
    getNameRoute(produitType) {
      return getRouteOfPatrimonialProduct(produitType);
    },
    isNormal(ligne) {
      return ligne.type === devisConf.NORMAL && !ligne.referencePersonnalise;
    },
    isRegroupement(ligne) {
      return ligne.type === devisConf.REGROUPEMENT && !ligne.referencePersonnalise;
    },
    isSousTotal(ligne) {
      return ligne.type === devisConf.SOUS_TOTAL;
    },
    isCommentaire(ligne) {
      return ligne.type === devisConf.COMMENTAIRE;
    },
    isRemise(ligne) {
      return ligne.type === devisConf.REMISE;
    },
    afficherLigneRemise(ligne) {
      return ligne.typeRemise === devisConf.PERSONALISE
        && ((ligne.lignesRemise.length > 1
          || (ligne.lignesRemise.length === 1 && ligne.lignesRemise[0].libelle !== null)))
        && this.displayRemise;
    },
    isRegroupementPersonalise(ligne) {
      return ligne.type === devisConf.PERSONNALISE;
    },
    isRegroupementPersonaliseWithReseauTempo(lignePerso) {
      return lignePerso.type === devisConf.PERSONNALISE && this.lignesCommande
        .some(ligne => ligne.type === devisConf.REGROUPEMENT
          && ligne.typeProduit === CATEGORIE_REGROUPEMENT
          && ligne.referencePersonnalise === lignePerso.referencePersonnalise
          && ligne.ligneReseau.lignesCmdSelProduits.length > 0);
    },
    openInfoFacesSelectReseauPersoOfReseauTempo(lignePerso) {
      this.ligneReseauTempoOfReseauPerso = this.lignesCommande
        .filter(ligne => ligne.type === devisConf.REGROUPEMENT
          && ligne.typeProduit === CATEGORIE_REGROUPEMENT
          && ligne.referencePersonnalise === lignePerso.referencePersonnalise
          && ligne.ligneReseau.lignesCmdSelProduits.length > 0);
      this.popUpSelectionFaceReseauPerso = true;
    },
    getMontantFace(ligne) {
      if (ligne.ligneReseau.qteFacesSouhaitees === 0
        || !ligne.ligneReseau.qteFacesSouhaitees) return 0;
      return calculArrondi(ligne.totalHtAvecLigneRemise / ligne.ligneReseau.qteFacesSouhaitees);
    },
    async gestionDispoLigneEnfant(ligne, ligneEnfant) {
      const montantFace = this.getMontantFace(ligneEnfant);
      const dateDebut = ligne.dateDebut;
      const dateFin = ligne.dateFin;
      if (this.typeDCF !== 'Facture') {
        const disponibilite = await getDisponibilite(ligne, dateDebut, dateFin);
        ligneEnfant.objectifAtteint = montantFace >= disponibilite.objectif;
        ligneEnfant.objectif = disponibilite.objectif;
      }
      ligneEnfant.montantFace = montantFace;
    },
    getNbEcranAssocies(ligne) {
      let result = [];
      if (ligne.produit.produitReseauNumerique.affectationsReseauEcran.length) {
        result = ligne.produit.produitReseauNumerique
          .affectationsReseauEcran.filter((affectation) => {
            const dateFinLiaison = affectation.dateFin ? new Date(affectation.dateFin)
              : INFINITE_DAY;
            return moment(ligne.dateDebut).isSameOrAfter(moment(affectation.dateDebut))
              && moment(ligne.dateFin).isSameOrBefore(dateFinLiaison);
          });
      }
      return result.length;
    },
    shouldDisplayFaceSelectedInfo(ligneCommande) {
      return [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_LC,
        CATEGORIE_REGROUPEMENT_MAIRIE,
      ].includes(ligneCommande.typeProduit)
        && (ligneCommande.ligneReseau.lignesCmdSelProduits?.length
        || (ligneCommande.lignesCmdSelOptionProduit?.length));
    },
  },
  async mounted() {
    this.loading = true;
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.activationYield.key,
      PARAMETRES_INTERNE_KEYS.moduleStockTiers.key]);
    if (this.parametresInterne(PARAMETRES_INTERNE_KEYS.activationYield.key)) {
      const promises = [];
      this.lignesCommande.forEach(ligne => {
        if (!ligne.lignesCommande) return;
        ligne.lignesCommande.forEach(ligneEnfant => {
          if (ligneEnfant.typeProduit === CATEGORIE_LOCATION
              && ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
            ligneEnfant.afficherObjectif = true;
            promises.push(this.gestionDispoLigneEnfant(ligne, ligneEnfant));
          } else ligneEnfant.afficherObjectif = false;
        });
      });
      await Promise.all(promises);
      this.loading = false;
    }
  },
};
</script>
